import { useEffect, useState } from 'react'

import { isValidAddress, isValidCityOrCounty, isValidPostcode, isValidCountry } from '../../utils/validateInput'
import ControlInput from './UpdateControlInput'

const UpdateClubAddress = ({ address, setAddressValid, setNewAddress }) => {
  const [streetAddress, setStreetAddress] = useState(address.streetAddress)
  const [city, setCity] = useState(address.city)
  const [county, setCounty] = useState(address.county)
  const [postcode, setPostcode] = useState(address.postcode)
  const [country, setCountry] = useState(address.country)

  const [streetAddressValid, setStreetAddressValid] = useState(true)
  const [cityValid, setCityValid] = useState(true)
  const [countyValid, setCountyValid] = useState(true)
  const [postcodeValid, setPostcodeValid] = useState(true)
  const [countryValid, setCountryValid] = useState(true)

  useEffect(() => {
    setNewAddress({
      streetAddress,
      city,
      county,
      postcode,
      country,
    })
  }, [streetAddress, city, county, postcode, country])

  useEffect(() => {
    if (
      streetAddressValid &&
      cityValid &&
      countyValid &&
      postcodeValid &&
      countryValid
    ) {
      setAddressValid(true)
    } else {
      setAddressValid(false)
    }
  }, [streetAddressValid, cityValid, countyValid, postcodeValid, countryValid])

  return (
    <div className="d-flex flex-column flex-sm-row  border-bottom p-2 custom-hover-tr">
      <b className="text-muted w-100 my-1">Club Address</b>
      <div className="w-100 d-flex flex-column gap-2">
        <ControlInput
          isValid={streetAddressValid}
          setValid={setStreetAddressValid}
          setValue={setStreetAddress}
          validTest={isValidAddress}
          value={streetAddress}
          name="street address"
          type="text"
          as="textarea"
          rows={1}
        />
        <ControlInput
          isValid={cityValid}
          setValid={setCityValid}
          setValue={setCity}
          validTest={isValidCityOrCounty}
          value={city}
          type="text"
          name="town or city"
        />
        <ControlInput
          isValid={countyValid}
          setValid={setCountyValid}
          setValue={setCounty}
          validTest={isValidCityOrCounty}
          value={county}
          type="text"
          name="county or state"
        />
        <ControlInput
          isValid={postcodeValid}
          setValid={setPostcodeValid}
          setValue={setPostcode}
          validTest={isValidPostcode}
          value={postcode}
          type="text"
          name="postcode"
        />
        <ControlInput
          isValid={countryValid}
          setValid={setCountryValid}
          setValue={setCountry}
          validTest={isValidCountry}
          value={country}
          type="text"
          name="country"
        />
      </div>
    </div>
  )
}

export default UpdateClubAddress